// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20r56","tabsBox":"styles_tabsBox__1ikSk","createButton":"styles_createButton__3HCA7"};